import { Button, Collapse } from '@insurancemenu/imenu-components-lib';
import { ChevronDown, ChevronUp } from '@insurancemenu/imenu-components-lib/dist/icons';
import React from 'react';
import {
  AddIconStyled,
  ContentStyled,
  PreviewStyled,
  SectionStyled,
  SubtitleStyled,
  TextWrapperStyled,
  TitleStyled,
} from './styles';

export interface CollapsiblePreviewSectionProps {
  title: string;
  subtitle: string;
  show: boolean;
  onToggle: () => void;
  toggleButtonText: string;
  children: React.ReactNode;
}

const CollapsiblePreviewSection: React.FC<CollapsiblePreviewSectionProps> = ({
  title,
  subtitle,
  show,
  onToggle,
  toggleButtonText,
  children,
}) => {
  return (
    <SectionStyled $show={show}>
      <PreviewStyled onClick={onToggle}>
        <AddIconStyled />
        <TextWrapperStyled>
          <TitleStyled>{title}</TitleStyled>
          <SubtitleStyled>{subtitle}</SubtitleStyled>
        </TextWrapperStyled>
        <Button
          type="text"
          color="primary"
          onClick={(event): void => {
            event.stopPropagation();
            onToggle();
          }}
          uppercase
          rightIconProp={
            show ? <ChevronUp width="2.4rem" height="2.4rem" /> : <ChevronDown width="2.4rem" height="2.4rem" />
          }
        >
          {show ? 'Hide' : 'Show'} {toggleButtonText}
        </Button>
      </PreviewStyled>
      <Collapse show={show}>
        <ContentStyled>{children}</ContentStyled>
      </Collapse>
    </SectionStyled>
  );
};

export default CollapsiblePreviewSection;
